<template>
  <div>
    <div class="setcontrol-content" id="main">
      <div class="set-sign-control" id="set-sign"></div>
      <!-- 滑动容器 -->
      <div class="contract-content" ref="cmain">
        <div class="contract-img-content">
          <div class="contract-imgs" id="contract-imgs" ref="contract">
            <div
              v-for="(item, idx) in signFileInfoArray"
              :key="idx"
              v-show="idx == active"
              class="file-item"
            >
              <div
                class="img-wrap"
                v-for="(contract, index) in signFileInfoArray[active]
                  .fileImgArray"
                :key="index"
                ref="imgWrap"
              >
                <img
                  :src="contract.src"
                  class="contract-img"
                  alt=""
                  ondragstart="return false"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="contract-page">
        <div class="pages-head">
          <span class="big">文件概览</span>
<!--          <span class="sub">共{{ signFileInfoArray.length }}份</span>-->
        </div>
        <el-collapse v-model="active" accordion @change="changeCollapse">
          <el-collapse-item
            :title="item.fileName ? item.fileName : '未命名合同'"
            :name="idx"
            v-for="(item, idx) in signFileInfoArray"
            :key="idx"
          >
            <div
              v-for="(img, imgIdx) in item.fileImgArray"
              :key="imgIdx"
              class="page-wrap"
            >
              <img
                :src="img.src"
                alt=""
                ondragstart="return false"
                :class="{ current: item.current == imgIdx }"
                @click="handleChangeContractImg(imgIdx)"
              />
              <div class="page" :class="{ current: item.current == imgIdx }">
                {{ imgIdx + 1 + "/" + item.fileImgArray.length }}
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    descData: {
      type: Object,
    },
  },
  data() {
    return {
      signFileInfoArray: [],
      active: 0,
      scrollWatchStatus: true, // 点击右侧缩略图时，暂时停止监听页面滚动
      renderOK: false,
      lastActive: "",
      saveLoading: false,
    };
  },
  watch: {
    descData() {
      this.handleGetSignDetailInfo();
    },
  },
  created() {
    this.handleGetSignDetailInfo();
  },
  mounted() {
    window.addEventListener("scroll", this.scrollEventHandler, true);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.scrollEventHandler, true);
  },
  methods: {
    scrollEventHandler(e) {
      let timeId;
      e = e || window.event;
      if (
        e.target.classList &&
        e.target.classList.contains("contract-content")
      ) {
        clearTimeout(timeId);
        timeId = setTimeout(() => {
          this.handleScroll();
        }, 100);
        // this.handleScroll();
      } else {
        clearTimeout(timeId);
      }
    },
    changeCollapse() {
      if (this.active === "") {
        this.active = this.lastActive;
      }
      this.lastActive = this.active;
      // this.$forceUpdate();
      this.signFileInfoArray[this.active].current = 0;
      document
        .getElementById("contract-imgs")
        .getElementsByClassName("file-item")
        [this.active].getElementsByClassName("img-wrap")[0]
        .scrollIntoView({
          behavior: "auto", // 平滑过渡
          block: "start", // 上边框与视窗顶部平齐。默认值
        });
    },
    handleScroll() {
      // dom滚动位置
      const scrollTop =
        document.getElementsByClassName("contract-content")[0].scrollTop;
      if (this.scrollWatchStatus) {
        const scaleFactor = 1;
        this.signFileInfoArray[this.active].fileImgArray.map((v, i) => {
          const offsetTop = document
            .getElementById("contract-imgs")
            .getElementsByClassName("file-item")
            [this.active].getElementsByClassName("img-wrap")[i].offsetTop;
          // 获取监听元素本身高度
          const scrollHeight = document
            .getElementById("contract-imgs")
            .getElementsByClassName("file-item")
            [this.active].getElementsByClassName("img-wrap")[i].scrollHeight;

          if (
            scrollTop >= offsetTop &&
            scrollTop <= offsetTop + scrollHeight * scaleFactor
          ) {
            this.signFileInfoArray[this.active].current = i;
            this.$forceUpdate();
          }
        });
      }
    },
    handleChangeContractImg(imgIdx) {
      let timer;
      this.signFileInfoArray[this.active].current = imgIdx;
      this.scrollWatchStatus = false;
      clearTimeout(timer);
      timer = setTimeout(() => {
        document
          .getElementById("contract-imgs")
          .getElementsByClassName("file-item")
          [this.active].getElementsByClassName("img-wrap")
          [imgIdx].scrollIntoView({
            behavior: "auto", // smooth 平滑过渡
            block: "start", // 上边框与视窗顶部平齐。默认值
          });

        let timer;
        clearTimeout(timer);
        timer = setTimeout(() => {
          this.scrollWatchStatus = true;
        }, 1300);
      }, 0);
      this.$forceUpdate();
    },

    handleGetSignDetailInfo() {
      this.descData.signFileInfoArray.map((item) => {
        item.current = 0;
        item.fileImgArray = item.fileImgArray.map((imgItem, imgIdx) => {
          const obj = {};
          obj.src = imgItem;
          return obj;
        });
      });
      this.signFileInfoArray = this.descData.signFileInfoArray;
      this.lastActive = this.active;
      this.$nextTick(() => {
        document.getElementsByClassName("contract-img")[0].onload = (ev) => {
          this.renderOK = true;
          document.getElementsByClassName("contract-img")[0].onload = null;
        };

        const collapseContentNodeList = document
          .getElementsByClassName("contract-page")[0]
          .getElementsByClassName("el-collapse-item__content");
        for (let i = 0, len = collapseContentNodeList.length; i < len; i++) {
          collapseContentNodeList[i].style.maxHeight =
            document.getElementsByClassName("contract-page")[0].offsetHeight -
            45 -
            48 * this.signFileInfoArray.length +
            "px";
        }
      });
    },
  },
};
</script>
<style>
.desc-drawer .el-drawer__header {
  margin: 0;
  height: 67px;
  padding: 15px;
  border-bottom: 1px solid #eee;
}
</style>
<style lang="scss" scoped>
.desc-wrap {
  padding: 0 30px 0 30px;
}
.btn-wrap {
  position: sticky;
  left: 0;
  bottom: 0;
  width: 100%;
  background: #fff;
  padding: 15px 30px;
  box-shadow: 0 -2px 10px 0 rgba(0, 0, 0, 0.1);
}

.set-sign-control {
  width: 1px;
  background: white;
  position: relative;
  z-index: 9;
  overflow-y: auto;
  height: calc(100vh - 67px);
  /deep/.el-form-item__label {
    line-height: normal;
    color: #303133;
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 20px;
  }
}

.contract-content {
  width: 710px;
  //   background: #f0f0f5;
  height: calc(100vh - 67px);
  overflow-y: auto;
  overflow-x: auto;
}
.contract-page {
  width: 238px;
  background: #fff;
  height: calc(100vh - 67px);
  overflow: hidden;
  border-left: 1px solid #eee;
  .el-collapse {
    max-height: calc(100% - 65px);
    /deep/ .el-collapse-item {
      // height: 100%;
      .el-collapse-item__header {
        padding: 0 10px 0 15%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 95%;
        display: block;
        position: relative;
        .el-collapse-item__arrow {
          position: absolute;
          left: 5%;
          top: 0;
          bottom: 0;
          margin: auto 0;
          width: 13px;
          height: 13px;
        }
      }
      .el-collapse-item__wrap {
        height: calc(100% - 48px);
        .el-collapse-item__content {
          overflow: auto;
          background: #F6F7FA;
          padding-top: 25px;
          padding-bottom: 1px;
        }
      }
    }
  }

  .pages-head {
    height: 45px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: 17px;
    padding-right: 13px;
    .big {
      font-size: 16px;
      font-weight: bold;
      color: #333333;
    }
    .sub {
      font-size: 14px;
      font-weight: 400;
      color: #999999;
    }
  }
  .page-wrap {
    width: 160px;
    margin: 0 auto;
    img {
      display: block;
      margin: 0 auto;
      width: 100%;
      &.current {
        outline: 1.5px solid #165DFF;
        // box-shadow: 0px 3px 10px 0px rgba(54, 153, 255, 0.1);
      }
    }
    .page {
      font-size: 12px;
      font-weight: 400;
      color: #999999;
      text-align: center;
      margin: 12px 0;
      &.current {
        color: #3699ff;
      }
    }
  }
}

.setcontrol-content {
  display: flex;
  justify-content: space-between;
  position: relative;
}

.contract-img-content {
  height: 100%;
}

.contract-imgs {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}

.contract-imgs .contract-img {
  display: block;
  width: 665px;
  height: auto;
  box-sizing: content-box;
  -ms-box-sizing: content-box;
  box-shadow: 0 2px 8px 2px rgba(68, 73, 77, 0.16);
}

.contract-imgs .orther-box-sign {
  max-width: 80px;
  max-height: 80px;
}
.contract-imgs .img-wrap {
  position: relative;
}
.contract-imgs .img-wrap + .img-wrap {
  margin-top: 30px;
}
</style>


